import RecommendationsSkeleton from '../components/Recommendations/RecommendationsSkeleton';
import { RecommendationsBasedOnInterest, usePrioritizeInterestRecommendations } from '../features/recommendations';
import HomePageSection from '../components/Layouts/HomePageSection';
import { RankedRecommendations } from '../features/recommendations/components/RankedRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
const RecommendationsContainer = () => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();
  const isRequesting = prioritizeInterestRecommendationsLoading;
  const error = prioritizeInterestRecommendationsError;
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": isRequesting,
      "data-test-id": "recommendation-cards-container",
      children: isRequesting || error ? /*#__PURE__*/_jsx(RecommendationsSkeleton, {
        error: error
      }) : !prioritizeInterestRecommendations ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(RankedRecommendations, {}) : /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {})
    })
  });
};
export default RecommendationsContainer;